/**
 * Pollo Wan V2.2 Flash：仅图生视频，generation/wanx/wan-v2-2-flash
 * input.image 必填（仅 URL），prompt 1-800，negativePrompt≤500，resolution 480P|720P，length 固定 5，seed
 */
import { isUrl } from './utils'

var RES_MAP = { '480p': '480P', '480P': '480P', '720p': '720P', '720P': '720P' }

function normalizeResolution(v) {
  if (!v) return '720P'
  var key = String(v).trim()
  return RES_MAP[key] || '720P'
}

export function buildBody(params) {
  var imageUrl = params.referenceImage && typeof params.referenceImage === 'string' ? params.referenceImage.trim() : ''
  if (!isUrl(imageUrl)) {
    throw new Error('Wan V2.2 Flash 仅支持图片转视频，referenceImage 须为有效 URL（HTTPS）')
  }
  var prompt = (params.prompt || '').trim().slice(0, 800)
  if (!prompt) throw new Error('视频提示（prompt）必填，1-800 字')
  var input = {
    image: imageUrl,
    prompt: prompt,
    resolution: normalizeResolution(params.videoRes || params.resolution),
    length: 5
  }
  var neg = (params.negativePrompt || '').trim().slice(0, 500)
  if (neg) input.negativePrompt = neg
  var seed = params.seed != null && params.seed !== '' && params.seed !== -1 ? parseInt(params.seed, 10) : null
  if (seed != null && !isNaN(seed) && seed <= 2147483647) input.seed = seed
  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = params.webhookUrl
  return body
}
